export default "__VITE_ASSET__Cxto1glA__"